export enum EarningsWidgetCategory {
  Eps,
  EpsGaap,
  Revenue,
}

export const EARNINGS_WIDGET_LABELS: Record<EarningsWidgetCategory, string> = {
  [EarningsWidgetCategory.Eps]: 'EPS Performance and Forecast',
  [EarningsWidgetCategory.EpsGaap]: 'GAAP EPS Performance and Forecast',
  [EarningsWidgetCategory.Revenue]: 'Revenue Performance and Forecast',
}

export const BAR_WIDTH = 72
export const CHART_HEIGHT = 250
export const LABELS_WIDTH = 28
export const LABELS_MARGIN = 22
export const BAR_WIDTH_NARROW = 52
export const BAR_GAP = 16
export const EXTRA_WIDTH = 44
export const CHART_MARGINS = { top: 2, right: 0, bottom: 0, left: 0 }
